module.exports = __webpack_public_path__ + "img/car-icon.f2332955.svg";